var map = {
	"./banner-light.de.html": [
		165,
		165
	],
	"./banner-light.en.html": [
		473,
		473
	],
	"./banner-light.es.html": [
		78,
		78
	],
	"./banner-light.fr.html": [
		898,
		898
	],
	"./banner-light.nl.html": [
		368,
		368
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 322;
module.exports = webpackAsyncContext;